export default function base64ToBlob(base64String, mimeType = 'application/zip', chunkSize = 1024 * 1024) {
	// Clean up any data URL prefix
	base64String = base64String.replace(/^data:.*;base64,/, '');

	const byteArrays = [];
	for (let offset = 0; offset < base64String.length; offset += chunkSize) {
		const chunk = base64String.slice(offset, offset + chunkSize);
		const decodedChunk = atob(chunk);
		const byteNumbers = new Array(decodedChunk.length);
		for (let i = 0; i < decodedChunk.length; i++) {
			byteNumbers[i] = decodedChunk.charCodeAt(i);
		}
		byteArrays.push(new Uint8Array(byteNumbers));
	}

	return new Blob(byteArrays, { type: mimeType });
}
